const excludedVoices = [
  "Brittney",
  "Mathias",
  "Pawel",
  "ASSAI_MINEIRO",
  "Laksh",
  "Mauricio",
  "David",
  "ASSAI_NACIONAL",
  "TESTE",
  "Mion",
  "Ju_Araripe",
  "Aria",
  "River",
  "Roger",
  "Viraj",
  "Ivanna"
];

export { excludedVoices };
